module.exports = __webpack_public_path__ + "img/app-store.f31e4cbf.svg";